import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { url_184, url_236 } from "../../../custom_utilities/api_services";
import { REFER_AND_EARN_TYPES } from "../../../containers/logged_user_components/user_refer_earn/utils";
import LoaderPopUp from "../../../components/loader/loader";
import ReferAndEarnContent from "../../../containers/logged_user_components/user_refer_earn/ReferAndEarnContent";
import CourseEnrollmentTermsAndConditions from "../../../containers/logged_user_components/user_refer_earn/courseEnrollmentTermsAndConditions/CourseEnrollmentTermsAndConditions";
import "../../../containers/logged_user_components/user_refer_earn/ReferAndEarn.scss";
import "./MySpaceReferAndEarn.scss";

const MySpaceReferAndEarn = ({ token, tokenType, loader, active = true }) => {
  const [data, setData] = useState({});
  const [referAndEarnData, setReferAndEarnData] = useState({});
  const [referAndEarnType, setReferAndEarnType] = useState(
    REFER_AND_EARN_TYPES.REFER_AND_EARN_DATA
  );
  const [referalListSize, setReferalListSize] = useState("referal_list_small");
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const handleTermsClick = () => {
    setReferAndEarnType(REFER_AND_EARN_TYPES.TERMS_AND_CONDITION);
  };

  const handleBackBtn = () => {
    setReferAndEarnType(REFER_AND_EARN_TYPES.REFER_AND_EARN_DATA);
    setReferalListSize("referal_list_small");
  };

  const getReferalCode = React.useCallback(async () => {
    if (!String(token || "").trim() || !tokenType) return;
    const headers = { Authorization: `${tokenType} ${token}` };
    try {
      const response = await axios.get(url_184, { headers });
      if (response.status === 200) {
        setData(response.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  }, [token, tokenType]);

  const getReferAndEarnData = React.useCallback(async () => {
    if (!String(token || "").trim() || !tokenType) return;
    const headers = { Authorization: `${tokenType} ${token}` };
    try {
      const response = await axios.get(url_236, { headers });
      if (response.data.status === 200) {
        setReferAndEarnData(response.data.data);
      }
    } catch (err) {
      console.log(err.message);
    }
  }, [token, tokenType]);

  useEffect(() => {
    if (!active) return;
    getReferalCode();
    getReferAndEarnData();
  }, [active, getReferalCode, getReferAndEarnData]);

  useEffect(() => {
    const setWidth = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", setWidth);
    return () => window.removeEventListener("resize", setWidth);
  }, []);

  return (
    <Fragment>
      <div className="refer_and_earn_panel refer_and_earn_panel--my-space">
        <div className="refer_and_earn_inner_wrapper">
          {referAndEarnType === REFER_AND_EARN_TYPES.REFER_AND_EARN_DATA && (
            <ReferAndEarnContent
              data={data}
              referAndEarnData={referAndEarnData}
              handleTermsClick={handleTermsClick}
              windowWidth={windowWidth}
              token={token}
              tokenType={tokenType}
              setReferAndEarnType={setReferAndEarnType}
              referalListSize={referalListSize}
              setReferalListSize={setReferalListSize}
              handleBackBtn={handleBackBtn}
              referAndEarnType={referAndEarnType}
              embeddedInMySpace
            />
          )}

          {referAndEarnType === REFER_AND_EARN_TYPES.TERMS_AND_CONDITION && (
            <div className="CourseEnrollmentTermsAndConditions">
              <CourseEnrollmentTermsAndConditions
                handleBackBtn={handleBackBtn}
                referAndEarnData={referAndEarnData}
              />
            </div>
          )}
        </div>
      </div>
      {loader && <LoaderPopUp />}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  token: state.auth.authToken,
  tokenType: state.auth.tokenType,
});

export default connect(mapStateToProps)(MySpaceReferAndEarn);
